import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient.js';
import { Link } from 'react-router-dom';

function HeadsUp() {
  const [characters, setCharacters] = useState([]);
  const [pair, setPair] = useState([]);
  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCharacters = async () => {
      const { data, error } = await supabase.from('characters').select('*');
      if (error) {
        console.error('Error cargando personajes:', error);
      } else {
        setCharacters(data);
        pickRandomPair(data);
        fetchRanking();
        setLoading(false);
      }
    };

    fetchCharacters();
  }, []);

  const pickRandomPair = (list) => {
    if (list.length < 2) return;

    const history = JSON.parse(localStorage.getItem('headsUpHistory')) || [];
    const remaining = list.filter((char) => !history.includes(char.id));

    let pool = remaining;

    if (remaining.length < 2) {
      localStorage.removeItem('headsUpHistory');
      pool = list;
    }

    let first = pool[Math.floor(Math.random() * pool.length)];
    let second;
    do {
      second = pool[Math.floor(Math.random() * pool.length)];
    } while (second.id === first.id);

    const updatedHistory = [...history, first.id, second.id];
    localStorage.setItem('headsUpHistory', JSON.stringify(updatedHistory));

    setPair([first, second]);
  };

  const voteFor = async (id) => {
    const { error } = await supabase.rpc('increment_vs_votes', { target_id: id });

    if (error) {
      console.error('Error al votar:', error);
    } else {
      pickRandomPair(characters);
      fetchRanking();
    }
  };

  const fetchRanking = async () => {
    const { data, error } = await supabase
      .from('characters')
      .select('id, name, image, vs_votes, universo, creador_url')
      .order('vs_votes', { ascending: false })
      .limit(75);

    if (error) {
      console.error('Error cargando ranking:', error);
    } else {
      setRanking(data);
    }
  };

  return (
    <div style={{ textAlign: 'center', padding: '2rem' }}>
      <h1>🔥 Heads Up: Pick Your Favorite!</h1>

      {loading ? (
        <p>Loading characters...</p>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '3rem', marginBottom: '2rem' }}>
          {pair.map((char) => (
            <div key={char.id}>
              <div onClick={() => voteFor(char.id)} style={{ cursor: 'pointer' }}>
                <img
                  src={char.image}
                  alt={char.name}
                  width={280}
                  height={280}
                  style={{ borderRadius: '16px' }}
                />
              </div>

              <div
                style={{
                  marginTop: '0.8rem',
                  padding: '0.5rem 1.2rem',
                  backgroundColor: '#e0f0ff',
                  border: '3px solid #007BFF',
                  borderRadius: '16px',
                  fontWeight: 'bold',
                  fontSize: '1.5rem',
                  color: '#007BFF',
                  display: 'inline-block',
                }}
              >
                {char.vs_votes ?? 0} VOTES
              </div>

              <p style={{ margin: '0.8rem 0 0.2rem', fontSize: '0.95rem' }}>
                <strong>UNIVERSE:</strong> {char.universo ?? '—'}
                <br />
                <strong>CREATED BY:</strong>{' '}
                <span
                  onClick={() => window.open(`/${char.creador_url}`, '_blank')}
                  style={{
                    textDecoration: 'none',
                    color: '#007BFF',
                    cursor: 'pointer',
                  }}
                >
                  {char.creador_url}
                </span>
              </p>
            </div>
          ))}
        </div>
      )}

      
    </div>
  );
}

export default HeadsUp;